/*
 * amb-newsletter-popup.js (28.09.2026, DBA) — Logik zum Snippet snippets/amb-newsletter-popup.liquid.
 * Ersetzt das Shopify-Forms-Overlay 941193 mit denselben Regeln:
 *   - öffnet einmal je Besucher nach 10 s oder beim Verlassen der Seite (Maus oben raus, nur Desktop)
 *   - nach dem Schließen bleibt unten links der Teaser „Spare 10%“, ein Klick öffnet das Pop-up wieder
 *   - nach erfolgreicher Anmeldung (Seite kommt mit posted_successfully zurück) nie wieder
 * Wartet, solange das Cookie-Banner (Pandectes) oder ein anderer Dialog offen ist oder ein Eingabefeld fokussiert ist;
 * öffnet auf der Seite gar nicht mehr, sobald ein Newsletter-Block (.amb-nlb, z. B. Footer) benutzt wird.
 * Teaser weicht unten fixierten Leisten aus (Kaufleiste), bei großem Consent-Sheet wird er ausgeblendet.
 * Zustand in localStorage 'amb-nl-popup': gezeigt | geschlossen | angemeldet. Ohne Speicher kein automatisches Öffnen.
 */
(() => {
  const root = document.querySelector('amb-newsletter-popup');
  if (!root) return;
  const dlg = root.querySelector('dialog.amb-nl');
  const teaser = root.querySelector('[data-amb-nl-auf]');
  if (!dlg || !teaser || typeof dlg.showModal !== 'function') return;

  const KEY = 'amb-nl-popup';
  const VERZOEGERUNG = 10000;
  const LEISTEN = ['.sticky-add-to-cart__bar'];
  const CONSENT = ['.pd-cookie-banner-window', '#pd-cp-preferences .pd-cp-ui'];

  const lies = () => { try { return localStorage.getItem(KEY) || ''; } catch (e) { return 'kein-speicher'; } };
  const schreib = (v) => { try { localStorage.setItem(KEY, v); } catch (e) { /* ohne Speicher */ } };

  const sichtbar = (el) => {
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden';
  };
  const consentOffen = () => CONSENT.some((s) => [...document.querySelectorAll(s)].some(sichtbar));
  const andererDialog = () => !!document.querySelector('dialog[open]:not(.amb-nl)');

  function oeffnen() {
    if (dlg.open) return;
    teaser.hidden = true;
    dlg.showModal();
  }

  function teaserZeigen() {
    if (lies() === 'angemeldet') return;
    teaser.hidden = false;
    teaserAbstand();
  }

  dlg.addEventListener('close', () => {
    if (lies() === 'angemeldet') return;
    schreib('geschlossen');
    teaserZeigen();
  });
  dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
  root.querySelector('[data-amb-nl-zu]').addEventListener('click', () => dlg.close());
  teaser.addEventListener('click', oeffnen);

  /* Teaser über unten fixierte Leisten heben, bei offenem Consent ausblenden. */
  function teaserAbstand() {
    if (teaser.hidden) return;
    if (consentOffen()) { teaser.style.visibility = 'hidden'; return; }
    teaser.style.visibility = '';
    let abstand = 0;
    for (const s of LEISTEN) {
      for (const el of document.querySelectorAll(s)) {
        if (!sichtbar(el)) continue;
        const r = el.getBoundingClientRect();
        if (r.bottom < window.innerHeight - 24) continue;
        abstand = Math.max(abstand, window.innerHeight - r.top);
      }
    }
    teaser.style.setProperty('--amb-nl-teaser-abstand', Math.round(abstand) + 'px');
  }
  let geplant = false;
  const abstandPlanen = () => {
    if (geplant || teaser.hidden) return;
    geplant = true;
    requestAnimationFrame(() => { geplant = false; teaserAbstand(); });
  };
  window.addEventListener('scroll', abstandPlanen, { passive: true });
  window.addEventListener('resize', abstandPlanen);
  setInterval(abstandPlanen, 1500);

  /* Rückkehr nach dem Absenden */
  const status = root.dataset.status;
  if (status === 'ok') {
    schreib('angemeldet');
    oeffnen();
    return;
  }
  if (status === 'fehler') {
    oeffnen();
    return;
  }

  const stand = lies();
  if (stand === 'angemeldet' || stand === 'kein-speicher') return;
  if (stand === 'gezeigt' || stand === 'geschlossen') { teaserZeigen(); return; }

  let erledigt = false;
  /* Wer ein anderes Newsletter-Formular (Footer, Seite) benutzt, bekommt auf dieser Seite kein Pop-up mehr. */
  document.addEventListener('focusin', (e) => {
    if (e.target.closest && e.target.closest('.amb-nlb')) erledigt = true;
  });
  /* Nicht mitten ins Tippen öffnen (Suche, Formulare): warten, bis kein Eingabefeld mehr fokussiert ist. */
  const tipptGerade = () => {
    const el = document.activeElement;
    if (!el || dlg.contains(el)) return false;
    return el.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName);
  };
  function versuchen() {
    if (erledigt) return;
    if (consentOffen() || andererDialog() || tipptGerade()) { setTimeout(versuchen, 2000); return; }
    erledigt = true;
    schreib('gezeigt');
    oeffnen();
  }
  setTimeout(versuchen, VERZOEGERUNG);
  if (window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mouseout', (e) => {
      if (!e.relatedTarget && e.clientY <= 0) versuchen();
    });
  }
})();
